import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { getIn } from 'final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import styles from './ErknmApproveInfoDetails.module.scss';
import { ErknmFieldMark } from '../../MainModule/components/ErknmFieldMark';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IErknmJudgmentDocumentProps {
  className?: string;
  disableToAdd: boolean;
  formRef: IKnmFormRef | undefined;
  name: string;
  watchOnly: boolean;
}

export const ErknmApproveInfoDocument = memo(
  ({ className = '', disableToAdd, formRef, name, watchOnly }: IErknmJudgmentDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={`${className} ${styles.FullWidth}`}>
        <div className="shared-group-label">
          Файл решения
          <span className="shared-no-wrap-text">
            <ErknmFieldMark fieldName={name} />
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || disableToAdd}
              onClick={openSignModal}
            />
          </span>
        </div>
        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
        <FormSpy subscription={{ errors: true }}>
          {props => {
            if (props.errors?.approveFile || props.errors?.changePlanReason) {
              const fieldError = getIn(props.errors, name);

              if (fieldError) {
                return <p className="shared-input-error">{fieldError}</p>;
              }
            }

            return null;
          }}
        </FormSpy>
      </div>
    );
  },
);
